import styled from "styled-components";
import Variables from "../../../../../../../assets/styleVariables";

export const NotifyContainer = styled.div`
  background-color: ${Variables.colors.white};
  width: 100%;
  //height: 115px;
  border: 1px solid ${Variables.colors.complementary_400};
  position: relative;
  //min-height: 100px;
  //display: flex;

  cursor: pointer;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 1px 4px 0 #ccc;
  margin: 8px 0;
  &:first-child {
    margin-top: 0;
  }
  .loading-parent {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
  }
  .notify-content-container {
    visibility: ${props => (props.loadingBox ? "hidden" : "visible")};
    display: flex;
    flex-direction: column;
    width: 100%;
    .top-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right-part {
        display: flex;
        align-items: center;
        .date {
          margin-right: 8px;
          color: ${Variables.colors.complementary_600};
          font-size: ${Variables.font_sizes.x_small};
        }
      }
      .is-link-card-icon {
        &:before {
          font-size: 10px;
          color: ${Variables.colors.tertiary_700};
        }
      }
      .remove-icon {
        padding: 4px;
        &:before {
          color: ${Variables.colors.complementary_700};
          font-size: 14px;
        }
      }
    }

    .title {
      margin-top: 8px;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x_medium};
    }

    .footer {
      display: flex;
      font-size: ${Variables.font_sizes.medium};
      flex-direction: column;

      .message {
        color: ${Variables.colors.complementary_700};
        margin: 4px 0;
        line-height: 1.57;
        max-width: 280px;
        text-align: justify;
      }
      .action {
        display: flex;
        flex-direction: row-reverse;
        font-size: ${Variables.font_sizes.x_small};
        font-weight: ${Variables.font_weight.medium};
        .button1 {
          cursor: pointer;
          padding: 8px 8px;
          background-color: ${Variables.colors.primary_600};
          color: ${Variables.colors.complementary};
        }
        .button2 {
          margin-right: 8px;
          cursor: pointer;
          padding: 8px 8px;
          background-color: ${Variables.colors.complementary_500};
          color: ${Variables.colors.complementary};
        }
      }
    }
  }

  .loading {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    & > div {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      height: 100% !important;
    }
    .spinner {
      margin: 0 !important;
      width: 48px !important;
      height: 48px !important;
    }
  }
`;

export const SeenMarkContainer = styled.div`
  .seen-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 14px;
    width: 14px;
    ${props => {
      if (props.seenLoading) {
        return `background-color:${Variables.colors.tertiary_600};
                    color:${Variables.colors.complementary};
            `;
      } else {
        return `background-color: ${
          props.isSeen
            ? Variables.colors.complementary
            : Variables.colors.primary_500
        };
                    border:2px solid ${Variables.colors.primary_400};
            `;
      }
    }};
    border-radius: 50%;
  }
`;
